/**
 * Turnstile token state for protected forms (login, etc.)
 */

import { useCallback, useState } from 'react'
import { isTurnstileEnabled, TURNSTILE_MESSAGES } from '../constants/turnstile.js'

export function useTurnstile () {
  const [token, setToken] = useState(null)
  const [resetSignal, setResetSignal] = useState(0)

  const reset = useCallback(() => {
    setToken(null)
    setResetSignal((n) => n + 1)
  }, [])

  const clearToken = useCallback(() => {
    setToken(null)
  }, [])

  /** @returns {string | null} User-facing error when token is required but missing */
  const getRequiredError = useCallback(() => {
    if (isTurnstileEnabled() && !token) {
      return TURNSTILE_MESSAGES.REQUIRED
    }
    return null
  }, [token])

  const canSubmit = !isTurnstileEnabled() || Boolean(token)

  return {
    token,
    setToken,
    resetSignal,
    reset,
    clearToken,
    getRequiredError,
    canSubmit,
    isEnabled: isTurnstileEnabled(),
  }
}
